var moduleMap = {
	"./Containers": () => {
		return __webpack_require__.e(/* __federation_expose_Containers */ 340).then(() => (() => ((__webpack_require__(97342)))));
	},
	"./HostWrapper": () => {
		return __webpack_require__.e(/* __federation_expose_HostWrapper */ 831).then(() => (() => ((__webpack_require__(46521)))));
	},
	"./ManagePaymentMethods": () => {
		return __webpack_require__.e(/* __federation_expose_ManagePaymentMethods */ 729).then(() => (() => ((__webpack_require__(53186)))));
	},
	"./PaymentConfigurations": () => {
		return __webpack_require__.e(/* __federation_expose_PaymentConfigurations */ 847).then(() => (() => ((__webpack_require__(41303)))));
	},
	"./PaymentHistory": () => {
		return __webpack_require__.e(/* __federation_expose_PaymentHistory */ 682).then(() => (() => ((__webpack_require__(60376)))));
	},
	"./Challenge": () => {
		return __webpack_require__.e(/* __federation_expose_Challenge */ 107).then(() => (() => ((__webpack_require__(59444)))));
	},
	"./InvoiceDialog": () => {
		return __webpack_require__.e(/* __federation_expose_InvoiceDialog */ 541).then(() => (() => ((__webpack_require__(75840)))));
	},
	"./InvoiceBlocksOrderDialog": () => {
		return __webpack_require__.e(/* __federation_expose_InvoiceBlocksOrderDialog */ 833).then(() => (() => ((__webpack_require__(88888)))));
	},
	"./PaymentDueModal": () => {
		return __webpack_require__.e(/* __federation_expose_PaymentDueModal */ 887).then(() => (() => ((__webpack_require__(16960)))));
	},
	"./PaymentModal": () => {
		return __webpack_require__.e(/* __federation_expose_PaymentModal */ 725).then(() => (() => ((__webpack_require__(43346)))));
	},
	"./LightspeedReports": () => {
		return __webpack_require__.e(/* __federation_expose_LightspeedReports */ 570).then(() => (() => ((__webpack_require__(21528)))));
	},
	"./PaymentPreferences": () => {
		return __webpack_require__.e(/* __federation_expose_PaymentPreferences */ 36).then(() => (() => ((__webpack_require__(30892)))));
	},
	"./ManagePaymentProcessing": () => {
		return __webpack_require__.e(/* __federation_expose_ManagePaymentProcessing */ 328).then(() => (() => ((__webpack_require__(77145)))));
	},
	"./AuditDialog": () => {
		return __webpack_require__.e(/* __federation_expose_AuditDialog */ 673).then(() => (() => ((__webpack_require__(94768)))));
	},
	"./ContactCreditCards": () => {
		return __webpack_require__.e(/* __federation_expose_ContactCreditCards */ 760).then(() => (() => ((__webpack_require__(77331)))));
	},
	"./Checkout": () => {
		return __webpack_require__.e(/* __federation_expose_Checkout */ 436).then(() => (() => ((__webpack_require__(25716)))));
	},
	"./CheckoutV3": () => {
		return __webpack_require__.e(/* __federation_expose_CheckoutV3 */ 373).then(() => (() => ((__webpack_require__(41111)))));
	},
	"./CheckoutConfirmation": () => {
		return __webpack_require__.e(/* __federation_expose_CheckoutConfirmation */ 419).then(() => (() => ((__webpack_require__(51182)))));
	},
	"./MobilePaymentsWrapper": () => {
		return __webpack_require__.e(/* __federation_expose_MobilePaymentsWrapper */ 792).then(() => (() => ((__webpack_require__(4550)))));
	},
	"./Invoices": () => {
		return __webpack_require__.e(/* __federation_expose_Invoices */ 432).then(() => (() => ((__webpack_require__(23043)))));
	},
	"./Select": () => {
		return __webpack_require__.e(/* __federation_expose_Select */ 880).then(() => (() => ((__webpack_require__(75106)))));
	},
	"./MultiSelect": () => {
		return __webpack_require__.e(/* __federation_expose_MultiSelect */ 319).then(() => (() => ((__webpack_require__(22680)))));
	},
	"./AsyncEventTracker": () => {
		return __webpack_require__.e(/* __federation_expose_AsyncEventTracker */ 256).then(() => (() => ((__webpack_require__(17592)))));
	},
	"./ShippingPromotionsListContainer": () => {
		return __webpack_require__.e(/* __federation_expose_ShippingPromotionsListContainer */ 941).then(() => (() => ((__webpack_require__(87850)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
__webpack_require__(18782)

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});